<template>
    <div id="product-details-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/productpage/' + idParam)"
                icon="arrow-left"
                :label="trans('pages.product_details.back_to_product')" />
            <actions-menu-item
                :v4="true"
                :action="() => setProductstatusDone(idParam, '', 1)"
                icon="check"
                :label="trans('pages.product_details.finished')" />
        </actions-menu>
        <template v-if="productDetails">
            <div class="product-default-fields">
                <div class="details-product">
                    <ui5-label for="product">{{ trans('pages.product_details.product') }}</ui5-label>
                    <ui5-input
                        type="Text"
                        name="product-productdetails"
                        id="product-productdetails"
                        :value="idInput"
                        @input="idInput = $event.target.value"
                        @blur="onInputBlur"
                        @keyup.enter="onInputBlur"
                        :placeholder="trans('pages.product_details.product_placeholder')" />
                </div>
                <div class="productpagefield">
                    <div>{{ trans('pages.product_details.customer') }} {{ productDetails.customerName }}</div>
                </div>
                <div class="productpagefield">
                    <div id="productdetailsname">
                        {{ trans('pages.product_details.name') }} {{ productDetails.name }}
                    </div>
                </div>
                <div class="productpagefield">
                    <div id="productdetailsref">
                        {{ trans('pages.product_details.reference') }} {{ productDetails.reference }}
                    </div>
                </div>
                <div class="productpagefield">
                    <div>{{ trans('pages.product_details.ral_nr') }} {{ productDetails.color.ralnr }}</div>
                </div>
                <div class="productpagefield">
                    <div>{{ trans('pages.product_details.ral_type') }} {{ productDetails.color.raltype }}</div>
                </div>
                <div class="productpagefield">
                    <div>{{ trans('pages.product_details.powder_nr') }} {{ productDetails.color.poedernr }}</div>
                </div>
                <div class="productpagefield">
                    <div>{{ trans('pages.product_details.rubber') }} {{ productDetails.color.tendon }}</div>
                </div>
                <div class="productpagefield">
                    <div class="productgroupdetailsstatus">
                        {{ trans('pages.product_details.status') }} {{ productDetails.productstatus }}
                    </div>
                </div>
                <p
                    v-if="productDetails.productstatus != 'GB'"
                    id="product-status-note">
                    {{ trans('pages.product_details.status_warning') }}
                </p>
                <p id="product-details-note">
                    {{ trans('pages.product_details.notes') }} {{ productDetails.note }}
                </p>
            </div>
            <div id="productdetailsfields">
                <div
                    class="prodFormGroup"
                    :id="'group-' + group[0].prodFormGroup"
                    :key="'group.' + groupIndex"
                    v-for="(group, groupIndex) in groupedFields">
                    <div
                        class="prodFormField"
                        :key="'field.' + field.datafieldId"
                        v-for="field in group">
                        <span class="productpagename">{{ field.label }}</span>
                        <span
                            :class="
                                field.emphOnProdForm == 1
                                    ? 'productpagevalueemph'
                                    : 'productpagevalue'
                            ">
                            <template v-if="field.datatype == 1">
                                {{ field.fieldvalue == 1 ? trans('pages.product_details.yes') : trans('pages.product_details.no') }}
                            </template>
                            <template v-else>
                                <template v-if="field.fieldvalue === null">
                                    null
                                </template>
                                <template v-else>
                                    {{ field.fieldvalue }}
                                </template>
                            </template>
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import productApi from '../api/product';
import { groupFields } from '../shared/productDetails';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), NavigationFunctionsMixin, localization],
    components: {
        ActionsMenu,
        ActionsMenuItem,
    },
    computed: {
        groupedFields() {
            if (!this.productDetails) {
                return [];
            }
            return groupFields(this.productDetails.datafields);
        },
    },
    mounted() {
        this.idInput = this.idParam;
    },
    data() {
        return {
            idInput: '',
            productDetails: null,
        };
    },
    methods: {
        onInputBlur() {
            if (this.idInput == this.idParam) {
                this.load();
            } else {
                this.$router.push('/productdetails/' + this.idInput);
            }
        },
        load() {
            if (this.idParam) {
                this.$store.commit(
                    'general/setPageTitle',
                    this.trans('pages.product_details.page_title', { id: this.idParam }),
                    { root: true }
                );
                productApi
                    .fetchExtendedDetails(this.idParam)
                    .then((response) => {
                        this.productDetails = response.data.data;
                    })
                    .catch(() => {
                        showErrorMessage(this.trans('pages.product_details.load_error'));
                    });
            }
        },
    },
};
</script>
